import React, {useEffect, useState} from "react";
import moment from 'moment';
import { useDispatch } from "react-redux";
import { openModal } from "../../../../../stores/reducers/videoCameras";
import styles from "./AvailableTime.module.scss";

const AvailableTime = ({currentTime, availableTime,setIsPlaying, setIsControls, intervalContinueStreaming }) => {

  const [time, setTime] = useState(availableTime);
  const dispatch = useDispatch();

  useEffect(() => {
      if(availableTime - Math.round(currentTime) === 0){
        clearInterval(intervalContinueStreaming.current);
        dispatch(openModal({key: "openBuyMoreModal", value: true}));
        setIsPlaying(false);
        setIsControls(false);
      }else{
          setTime(availableTime - Math.round(currentTime));
      }
  },[currentTime, availableTime]);

  return (
    <>
      <div className={styles.description}>
          { `By selecting view you will begin a livestream of the camera and will deduct from your available viewing time.`}
      </div>

      <h5>
          Available Time:{" "}
          {moment.utc(moment.duration(time,'seconds').as('milliseconds')).format('HH:mm:ss')}
      </h5>

    </>
  );
};

export default AvailableTime;
